import { render, staticRenderFns } from "./EmailSidebar.vue?vue&type=template&id=5f532536"
import script from "./EmailSidebar.vue?vue&type=script&lang=js"
export * from "./EmailSidebar.vue?vue&type=script&lang=js"
import style0 from "./EmailSidebar.vue?vue&type=style&index=0&id=5f532536&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports